import { methodGet } from './api/api'

export const getClients = async (params:string = '') => methodGet({
  path: `company/companies?expand=projects,tasks,price_estimate,clients${params}&per-page=500`,
})
